import { render, staticRenderFns } from "./notification_expirations.vue?vue&type=template&id=8af0e91e&scoped=true&"
import script from "./notification_expirations.vue?vue&type=script&lang=js&"
export * from "./notification_expirations.vue?vue&type=script&lang=js&"
import style0 from "./notification_expirations.vue?vue&type=style&index=0&id=8af0e91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af0e91e",
  null
  
)

export default component.exports